import tippy from 'tippy.js'
import he from 'he'

//tippy('button[aria-label="Information"]', {
//    theme: 'light classic',
//    animation: 'fade',
//    placement: 'right',
//    interactive: true, // able to hover over and click in tooltip
//})

//// set up for cottage page too.
//tippy('.favourite-button', {
//    //theme: 'light classic shortlist',
//    theme: 'light',
//    animation: 'fade',
//    allowHTML: true,
//    trigger: 'click',
//    interactive: true,
//    onShow(reference) {
//        let html = ''
//        const heart = '<svg class="heart-icon" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 15.6 15.2" aria-label="Favourite"><path d="M517.3-75.2,512-69.7l-.6.6-.6-.6-5.3-5.5a6.1,6.1,0,0,1-1.9-4.7,4.7,4.7,0,0,1,1.6-3.4,4.7,4.7,0,0,1,2.9-1,3.8,3.8,0,0,1,3.2,1.5,3.8,3.8,0,0,1,3.2-1.5,4.7,4.7,0,0,1,2.9,1,4.7,4.7,0,0,1,1.6,3.4A6.1,6.1,0,0,1,517.3-75.2Zm.4-4.6a3.1,3.1,0,0,0-1-2.2,3.1,3.1,0,0,0-2-.7,2.3,2.3,0,0,0-2.5,2.2.7.7,0,0,1-.8.6.7.7,0,0,1-.8-.6,2.3,2.3,0,0,0-2.5-2.2,3.1,3.1,0,0,0-2,.7,3.1,3.1,0,0,0-1,2.2,4.6,4.6,0,0,0,1.5,3.5l4.7,4.9,4.7-4.9A4.6,4.6,0,0,0,517.7-79.8Z" transform="translate(-503.6 84.3)" /></svg >'
//        const code = reference.reference.getAttribute('data-code')
//        if (window.sl.shortlists.length > 0) {
//            window.sl.shortlists.forEach((shortlist) => {
//                let active = 'false'
//                if (shortlist.items.find(i => i.value === code)) { active = 'true' }
//                html += `<div class='set-item' data-active="${active}"  onclick='window.sl.ChangeSetValueMulti()'><p data-guid='${shortlist.id}' data-code='${code}' data-inlist='${active}'><span>${he.encode(shortlist.name)}</span> ${heart}</p></div>`
//            })
//        } else {
//            html += `<div class='set-item' onclick='window.sl.AddCottageToShortListMultiList(${code})'><p data-guid='' data-code='${code}' data-inlist=''><span>Default</span> ${heart}</p></div>`
//        }
//        html += `<div class="set-item modal-open" aria-controls="createShortlist" data-code='${code}'><p data-inlist=""><span>Create new shortlist</span></p></div>`
//        reference.setContent(html)
//    },
//})

//tippy('.results-list__price-info', {
//    //triggerTarget: '.results-list__price-info',
///*    target: '.results-list__price-info',*/
//    theme: 'light classic',
//    animation: 'fade',
//    arrow: true,
//    //multiple: true,
//    onShow(reference) {
//    },
//})


tippy('button[aria-label="Information-Top"]', {
    theme: 'light classic',
    animation: 'fade',
    placement: 'top',
    arrow: true,
    interactive: true, // able to hover over and click in tooltip
})

tippy('button[aria-label="Information"]', {
    theme: 'light classic',
    animation: 'fade',
    placement: 'right',
    arrow: true,
    interactive: true, // able to hover over and click in tooltip
})

// set up for cottage page too.
tippy('.results-list__items, #map, .cottage', {
    target: '.favourite-button[data-multi="true"]',
    theme: 'light classic shortlist',
    animation: 'fade',
    arrow: true,
    multiple: true,
    trigger: 'click',
    interactive: true,
    onShow(reference) {
        let html = ''
        const heart = '<svg class="heart-icon" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 15.6 15.2" aria-label="Favourite"><path d="M517.3-75.2,512-69.7l-.6.6-.6-.6-5.3-5.5a6.1,6.1,0,0,1-1.9-4.7,4.7,4.7,0,0,1,1.6-3.4,4.7,4.7,0,0,1,2.9-1,3.8,3.8,0,0,1,3.2,1.5,3.8,3.8,0,0,1,3.2-1.5,4.7,4.7,0,0,1,2.9,1,4.7,4.7,0,0,1,1.6,3.4A6.1,6.1,0,0,1,517.3-75.2Zm.4-4.6a3.1,3.1,0,0,0-1-2.2,3.1,3.1,0,0,0-2-.7,2.3,2.3,0,0,0-2.5,2.2.7.7,0,0,1-.8.6.7.7,0,0,1-.8-.6,2.3,2.3,0,0,0-2.5-2.2,3.1,3.1,0,0,0-2,.7,3.1,3.1,0,0,0-1,2.2,4.6,4.6,0,0,0,1.5,3.5l4.7,4.9,4.7-4.9A4.6,4.6,0,0,0,517.7-79.8Z" transform="translate(-503.6 84.3)" /></svg >'
        const code = reference.reference.getAttribute('data-code')
        if (window.sl.shortlists.length > 0) {
            window.sl.shortlists.forEach((shortlist) => {
                let active = 'false'
                if (shortlist.items.find(i => i.value === code)) { active = 'true' }
                html += `<div class='set-item' data-active="${active}"  onclick='window.sl.ChangeSetValueMulti()'><p data-guid='${shortlist.id}' data-code='${code}' data-inlist='${active}'><span>${he.encode(shortlist.name)}</span> ${heart}</p></div>`
            })
        } else {
            html += `<div class='set-item' onclick='window.sl.AddCottageToShortListMultiList(${code})'><p data-guid='' data-code='${code}' data-inlist=''><span>Default</span> ${heart}</p></div>`
        }
        html += `<div class="set-item modal-open" aria-controls="createShortlist" data-code='${code}'><p data-inlist=""><span>Create new shortlist</span></p></div>`
        reference.setContent(html)
    },
})

tippy('.results-list__items', {
    target: '.results-list__price-info',
    theme: 'light classic',
    animation: 'fade',
    arrow: true,
    multiple: true,
    onShow(reference) {
    },
})